// Where the login page sends the user once they are signed in: the URL the
// login page was shown at (App.tsx renders LoginPage for every unauthenticated
// URL), unless that URL is the root or /login itself. A deep link — e.g. the
// Eloverblik consent return /consent/eloverblik/<id> — survives a login.
const ENTRY_PATHS = new Set(['', '/', '/login', '/login/'])

// True when `path` is a same-origin, in-app path: starts with a single '/'
// (not '//', which browsers resolve as a protocol-relative URL to another
// origin) and contains no backslash (which some browsers also treat as a
// path separator, letting '/\evil.example' behave like '//evil.example').
export function isSameOriginPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.includes('\\')
}

export function postLoginTarget(loc: { pathname: string; search: string; hash: string }): string {
  const { pathname, search, hash } = loc
  if (ENTRY_PATHS.has(pathname)) return '/dashboard'
  if (!isSameOriginPath(pathname)) return '/dashboard'
  return `${pathname}${search}${hash}`
}
